import { Component, computed, inject, input, Signal } from '@angular/core';
import { DashboardCountComponent } from '../dashboard-count/dashboard-count.component';
import { CountData, CountHeader } from '@r1-compass-library/models/reporting/dashboard-count.model';
import { MatDialog } from '@angular/material/dialog';
import { RecommendationsDashboardComponent, RecommendationsDashboardData } from '../dialogs/recommendations-dashboard/recommendations-dashboard.component';
import { ReportingDataStore } from '../store/reporting-data.store';
import { PlayResultDetailsActionType } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-app-recommendations-count',
    standalone: true,
    imports: [DashboardCountComponent],
    template: `
        <r1-compass-app-dashboard-count [header]="header()" [count]="count()" (viewDetails)="viewDetails()" />
    `,
})
export class RecommendationsCountComponent {
    actionType = input.required<PlayResultDetailsActionType>();
    selectedDivisionIds = input.required<number[]>();

    header: Signal<CountHeader> = computed(() => ({
        title: this.actionType() === 'create' ? 'Recommendations Created' : 'Recommedations Updated',
        subtitle: 'Last 24 Hours',
    }));

    count: Signal<CountData> = computed(() => {
        const dailyAggregate = this.#store
                .selectSignal(store =>
                    this.actionType() === 'create'
                        ? store.recommendationsCreatedLast24Hours
                        : store.recommendationsUpdatedLast24Hours)()
                .map(res => res.aggregate)
                .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        return {
            class: '', // The class asserts that this will be defined, but it is not.
            value: dailyAggregate ?? 0,
        };
    });

    readonly #dialog = inject(MatDialog);
    readonly #store = inject(ReportingDataStore);

    viewDetails() {
        this.#dialog.open<RecommendationsDashboardComponent, RecommendationsDashboardData, any>(RecommendationsDashboardComponent, {
            width: 'calc(100vw - 5px)',
            height: 'calc(100vh - 40px)',
            disableClose: false,
            restoreFocus: false,
            data: {
                header: this.header(),
                count: this.count(),
                selectedDivisionIds: this.selectedDivisionIds(),
                actionType: this.actionType()
            },
        });
    }
}
